<template>
  <ExternalQueryList
      endpoint="/api/v2/people"
      :headlines="headlines"
      :filters="filters"
      :can-update="() => true"
      @show="person => $router.push(getUrl(person))"
  >
    <template v-slot:default="{ row: person }">
      <td class="ellipsis">
        <router-link :to="'/people/' + person.id">
          {{ person.attributes.name }}
        </router-link>
      </td>

      <td>
        <div class="pull-right">
          <i v-if="person.attributes.has_active_membership" class="fa fa-book-reader" v-tooltip="'Current Member'"></i>

          <i v-else-if="person.attributes.has_membership" class="fa fa-book-reader" v-tooltip="'Expired/Trial Member'" style="opacity: 0.2"></i>

          <i v-else class="fa fa-book-reader" style="opacity: 0"></i>
        </div>
      </td>

      <td class="ellipsis">
        <router-link v-if="person.attributes.company_id" :to="'/companies/' + person.attributes.company_id">
          {{ person.attributes.company_name }}
        </router-link>
      </td>

      <td>
        <template v-for="tag in person.attributes.tags">
          <span class="label" :style="{'background-color': tag.color}">
            {{ tag.name }}
          </span>&nbsp;
        </template>
      </td>

      <td>
        {{ person.attributes.created_at | date }}
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {
    ExternalQueryList,
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Name', sort_column: 'name'},
        {width: 1},
        {width: 5, text: 'Company'},
        {width: 5, text: 'Tag'},
        {width: 5, text: 'Created At', sort_column: 'created_at'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 12,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'typeahead',
            endpoint:'/api/v2/companies',
            name: 'company_id',
            placeholder: 'Search Companies...'
          },
          {
            width: 4,
            widget: 'text',
            name: 'tag',
            placeholder: 'Search Tags...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(person) {
      return '/people/' + person.id
    }
  }
}
</script>
